import React from "react";
import data from "../../Json/Aboutpage/section2.json";
const Section2 = () => {
  return (
    <div className="w-full bg-[#EEF0ED] bg-cover">
      <div className="2xl:container mx-auto w-full md:px-14 my-10   lg:px-20 px-6">
        <div className="w-full  flex flex-col lg:flex-row justify-center gap-4 sm:gap-8  md:gap-10 lg:justify-between bg-white rounded-[24px] p-6 sm:p-8 sm:py-12 sm:px-10">
          <div className="w-full lg:w-1/2">
            <div className="w-full max-lg:text-center lg:max-w-[450px]">
              <h6 className="font-medium text-aboutblack text-18 sm:text-24 ">
                {data.heading}
              </h6>
              <p className="text-aboutpara text-14 sm:text-18 mt-3 sm:mt-4">{data.desc}</p>
            </div>
          </div>
          <div className="flex flex-row w-full lg:w-1/2 justify-center lg:justify-between gap-5">
            <div className="flex flex-col items-center text-center gap-2 sm:gap-5">
              <h6 className="text-aboutblack text-28  sm:text-48 md:text-52 lg:text-56 font-medium">
                {data.experince.count}
              </h6>
              <p className="text-12 sm:text-16 font-medium text-aboutpara">
                {data.experince.desc}
              </p>
            </div>
            <div className="flex flex-col items-center text-center gap-2 sm:gap-5">
              <h6 className="text-aboutblack  text-28  sm:text-48 md:text-52 lg:text-56  font-medium">
                {data.client.count}
              </h6>
              <p className="text-12 sm:text-16 font-medium text-aboutpara">
                {data.client.desc}
              </p>
            </div>
            <div className="flex flex-col items-center text-center gap-2 sm:gap-5">
              <h6 className="text-aboutblack  text-28  sm:text-48 md:text-52 lg:text-56  font-medium">
                {data.projects.count}
              </h6>
              <p className="text-12 sm:text-16 font-medium text-aboutpara">
                {data.projects.desc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
